/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React, {useCallback} from 'react'
import PropTypes from 'prop-types'
import RadioFilter from '../../../components/filter-sort/radio-filter'

const RadioRefinements = ({filter, toggleFilter, selectedFilters}) => {
    const onChange = useCallback(
        (option, {filterId, select, multiple}) => {
            toggleFilter?.(option, filterId, !select, multiple)
        },
        [toggleFilter]
    )

    return (
        <RadioFilter
            filterId={filter.attributeId}
            options={filter.values}
            selectedOption={selectedFilters[0]}
            onChange={onChange}
        />
    )
}

RadioRefinements.propTypes = {
    filter: PropTypes.object,
    toggleFilter: PropTypes.func,
    selectedFilters: PropTypes.array
}

export default RadioRefinements
